
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DsEditor from "@/components/ds-editor/ds-editor.vue";
@Component({
  components: {
    DsEditor,
  },
})
export default class Name extends Vue {
  @Prop()
  private type: any;
  @Prop()
  private data: any;
  @Watch("data", { immediate: true })
  private dataChange() {
    this.detail = JSON.parse(JSON.stringify(this.data));
  }
  private detail: any = {};
  private editorChange(e: any) {
    this.detail.suggest = e;
    this.updateData();
  }
  private updateData() {
    this.$emit("update", this.detail);
  }
}
